import { ICImage } from "../core-component/ui";
import UseTranslationHook from "../hooks/UseTranslationHook";
import { localStorageUtils } from "../utils/LocalStorageUtil";
import { routeAdmin, routeMaster } from "../routes/AuthRoutePath";
import { routePublic } from "../routes/PublicRoutePath";

const SomethingWentWrong = () => {
  const { t } = UseTranslationHook();
  const storedAccessToken = localStorageUtils.getAccessToken();
  const hrefHomePageValue = `/${routeMaster.admin}/${routeAdmin.lookup}`;
  const hrefLoginPageValue = `/${routePublic.login}`;
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-subtle text-center">
      <div className="max-w-lg">
        <ICImage
          src={require("../../src/assets/image/Error500.gif")}
          containerClass="rounded-lg"
        />
      </div>
      <div className="max-w-lg">
        <h1 className="text-4xl font-bold text-default mb-4">
          {t("internal_server_error")}
        </h1>
        <p className="text-lg text-muted mb-6">{t("500_error_massage")}</p>
        <button
          onClick={() => {
            storedAccessToken
              ? (window.location.href = hrefHomePageValue)
              : (window.location.href = hrefLoginPageValue);
          }}
          className="px-6 py-3 bg-accent-emphasis text-on-accent text-sm font-medium rounded-lg shadow hover:bg-accent-muted transition hover:text-muted"
        >
          {t("go_to_home_button")}
        </button>
      </div>
    </div>
  );
};

export default SomethingWentWrong;
